import { render } from "./TeacherEditTable.vue?vue&type=template&id=43b73e88&scoped=true&ts=true"
import script from "./TeacherEditTable.vue?vue&type=script&lang=ts"
export * from "./TeacherEditTable.vue?vue&type=script&lang=ts"

import "./TeacherEditTable.vue?vue&type=style&index=0&id=43b73e88&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b73e88"]])

export default __exports__